import React from 'react';
import PropTypes from 'prop-types';
import {
  Link,
} from '@resy/ui-kitchen';
import { sanitizeString } from '../../../../../../../ui-kitchen/src/utils/sanitizeString';
import { CTA_EVENT_NAME } from '../../../AmexMarketingUtils/constants';
import { handleMktAnalytics } from '../../../AmexMarketingUtils/AmexUtils';
import './AmexExperientialBannerCarouselSlide.scss';

const AmexExperientialBannerCarouselSlide = (
  {
    index,
    currentSlide,
    image: {
      desktop: imageDesktop,
      mobile: imageMobile,
    },
    retina_image: {
      desktop: retinaImageDesktop,
      mobile: retinaImageMobile,
    },
    header: headingValue,
    copy: contentValue,
    cta,
    matchMedia,
    baseRequestUrl,
    Analytics,
  }
) => {
  const ctaLabel = cta?.label;
  const ctaUrl = cta?.url;

  const devicePixelRatio2x = (typeof window.matchMedia === 'function' && window.matchMedia('(-webkit-min-device-pixel-ratio: 1.5), (min-resolution: 1.5dppx)').matches);

  let bannerDesktop = '';
  let bannerMobile = '';

  if (devicePixelRatio2x) {
    bannerDesktop = retinaImageDesktop || imageDesktop;
    bannerMobile = retinaImageMobile || imageMobile;
  } else {
    bannerDesktop = imageDesktop;
    bannerMobile = imageMobile;
  }
  const bannerBgImage = `url(${baseRequestUrl}Experiential/bannerImages/${bannerDesktop})`;

  const sanitizedHeadingValue = sanitizeString(headingValue);
  const sanitizedContentValue = sanitizeString(contentValue);

  const handleAnalyticsClick = (itemName) => {
    const extraParam = {
      action_name: 'Banner - CTA Click',
      item_name: itemName,
    };
    handleMktAnalytics(Analytics.event, CTA_EVENT_NAME, extraParam);
  };

  const contentDisplay = () => (
    <>
      {headingValue && (
        <h1
          id={`slide_heading${index}`}
          className="AmexExperientialBannerCarouselSlide__content--title"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: sanitizedHeadingValue,
          }}
        />
      )}
      {contentValue && (
        <p
          className="AmexExperientialBannerCarouselSlide__content--text"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: sanitizedContentValue,
          }}
        />
      )}
      {(ctaLabel && ctaUrl)
      && (
        <Link
          href={ctaUrl}
          className="AmexExperientialBannerCarouselSlide__content--cta"
          {...(!currentSlide && { tabIndex: -1 })}
          onClick={() => handleAnalyticsClick(sanitizedHeadingValue)}
        >
          {ctaLabel}
        </Link>
      )}
    </>
  );

  return (
    <div
      className={`AmexExperientialBannerCarouselSlide ${currentSlide ? 'current' : ''}`}
    >
      <div className="AmexExperientialBannerCarouselSlide__wrapper">
        {matchMedia.md && (
          <div
            className="AmexExperientialBannerCarouselSlide__image"
            style={{ backgroundImage: bannerBgImage }}
          />
        )}
        <div className="container">
          <div className="AmexExperientialBannerCarouselSlide__content">
            {contentDisplay()}
          </div>
        </div>
        {!matchMedia.md && (
          <img
            className="AmexExperientialBannerCarouselSlide__image-mobile"
            src={`${baseRequestUrl}Experiential/bannerImages/${bannerMobile}`}
            alt=""
          />
        )}
      </div>
    </div>
  );
};

AmexExperientialBannerCarouselSlide.propTypes = {
  index: PropTypes.number.isRequired,
  baseRequestUrl: PropTypes.string.isRequired,
  currentSlide: PropTypes.bool.isRequired,
  image: PropTypes.shape({
    desktop: PropTypes.string,
    mobile: PropTypes.string,
  }).isRequired,
  retina_image: PropTypes.shape({
    desktop: PropTypes.string,
    mobile: PropTypes.string,
  }),
  header: PropTypes.string.isRequired,
  copy: PropTypes.string.isRequired,
  cta: PropTypes.shape({
    label: PropTypes.string,
    url: PropTypes.string,
  }),
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
};

AmexExperientialBannerCarouselSlide.defaultProps = {
  cta: {
    label: null,
    url: null,
  },
  retina_image: {
    desktop: null,
    mobile: null,
  },
};

export default AmexExperientialBannerCarouselSlide;
